import { appSettingsGetCustomEventProperties } from "@dashboardApi/apis/appSettingsGetCustomEventProperties";
import { appSettingsSegmentablePropertyUsage } from "@dashboardApi/apis/appSettingsSegmentablePropertyUsage";

import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppGroupIdEventPropertiesSettingsCacheKeys: AllRouteEndpoints[] = [
  appSettingsGetCustomEventProperties,
  appSettingsSegmentablePropertyUsage,
];
